/**
 * Helper function for resizing background images
 *
 * @param {*} $images
 */
const baGalleryImageResize = $images => {
	$images.each((i, el) => {
		const $this = $(el);
		const aspect = parseFloat($this.data('aspect'));
		const isPortrait = aspect >= 1;
		const $parent = $this.parent();

		// Calculate what the new width should be based on the height of the parent container
		const newWidth = $parent.outerHeight() / aspect;

		// Set the background size proportional to the containing element (accounting for original aspect ratio)
		// - If the image is a portrait orientation
		// - Or if the width of the image is smaller than the parent
		// - Calculate the image height based on the width of the parent
		if (isPortrait || newWidth < $parent.outerWidth()) {
			const newHeight = $parent.outerWidth() * aspect;
			$this.css('background-size', `${$parent.outerWidth()}px ${newHeight}px`);
		// Otherwise, fallback to setting the image width based on the parent height
		} else {
			$this.css('background-size', `${newWidth}px ${$parent.outerHeight()}px`);
		}

		// Signal initialized
		$parent.addClass('initialized');
	});
}

/**
 * Size all background images on page load
 */
baGalleryImageResize($('.ba-image__slot'));

/**
 * Bind input[type=range] element to revealing images.
 * Trigger change on page load so images start at correct size.
 */
$(".ba-image__slider").on("input change", e => {
	const sliderPos = parseInt(e.target.value);
	const $this = $(e.currentTarget);
	const $parent = $this.parents('.ba-image');

	// Update the width of the foreground image
	$parent.find('.foreground').css('width', `${sliderPos-0.5}%`);

	// Update the position of the slider button
	$this.siblings('.ba-image__slider-handle').css('left', `calc(${sliderPos}% - 23px)`)
}).trigger('change');

/**
 * Listen for load more events and resize/init images
 */
$('.block-load-more-grid').on('trmk.loadMoreBlock.showAll', e => {
	baGalleryImageResize($(e.currentTarget).find('.ba-image__slot'));
});
